import React from 'react'
import PropTypes from 'prop-types'

import { Form, Glyphicon, Alert } from 'react-bootstrap'
import InputField, { useFormValues } from './../../../FormInputComponents/InputField'

import BrandSuggestion from './../../../Suggestion/BrandSuggestion'
import MerchantSuggestion from './../../../Suggestion/MerchantSuggestion'

import useFormMerchantBrandFilds from './useFormMerchantBrandFilds'
import useModalUISettings from './../../Common/useModalUISettings'
import useFormButtons from './../../Common/useFormButtons'
import useMode from './../../Common/useMode'

import NoteFields from './../../Common/NoteFields'
import CommonRuleModalButtons from './../../Common/CommonRuleModalButtons'

export default function MerchantBrandRuleModal({ value, isRequest, onOkHandler, onRejectHandler, isReadOnly }) {
  const { id, merchantId, merchantName, brandId, brandFullPath, request_notes, review_notes } = value
  const mode = useMode(isRequest, isReadOnly, id)

  const { values, isFormChanged, handleFieldChange, updateValue } = useFormValues({
    id: id ?? null,
    brandId: brandId ?? null,
    brandFullPath: brandFullPath ?? null,
    merchantId: merchantId ?? null,
    merchantName: merchantName ?? null,
    request_notes: request_notes ?? null,
    review_notes: review_notes ?? null
  })

  const [handleMerchantChange, handleBrandChange] = useFormMerchantBrandFilds(values, updateValue, mode)

  const isAllFieldsFilled = values.merchantId && values.brandId
  const fieldsNames = 'Merchant and Brand'
  const isRuleActiveFunc = rule => rule.isActive && rule.brandIsActive && rule.merchantIsActive
  const { ruleInfoMessage, ruleInfoStyle, okButtonName, isOkButtonDisabled } = useModalUISettings({
    prevRuleId: values.id,
    isAllFieldsFilled,
    isFormChanged,
    fieldsNames,
    isRuleActiveFunc,
    mode
  })

  const sentFieldsForRules = ['merchantId', 'brandId']
  const sentFieldsForRequests = ['merchantName', 'brandFullPath', 'request_notes', 'review_notes']
  const { handleOkButton, handleRejectButton, handleCancelButton } = useFormButtons({
    onOkHandler,
    onRejectHandler,
    values,
    sentFieldsForRules,
    sentFieldsForRequests,
    isRequest
  })

  return (
    <Form className="text-left" horizontal>
      <InputField validationState={values.merchantId === undefined ? 'error' : null} required label={'Merchant'}>
        <MerchantSuggestion
          selectedId={values.merchantId}
          selectedLabel={values.merchantName}
          changeCallback={handleMerchantChange}
          readOnly={mode.isRequestApprove || mode.isRequestView}
        />
      </InputField>
      <InputField validationState={values.brandId === undefined ? 'error' : null} required label={'Brand'}>
        <BrandSuggestion
          selectedId={values.brandId}
          selectedLabel={values.brandFullPath}
          changeCallback={handleBrandChange}
          readOnly={mode.isRequestApprove || mode.isRequestView}
        />
      </InputField>

      {!mode.isRequestView && (
        <Alert bsStyle={ruleInfoStyle}>
          <Glyphicon className="padding-rigt-standard" glyph="info-sign" />
          {ruleInfoMessage}
        </Alert>
      )}

      <NoteFields
        mode={mode}
        request_notes={values.request_notes}
        review_notes={values.review_notes}
        handleFieldChange={handleFieldChange}
      />

      <CommonRuleModalButtons
        handleOkButton={handleOkButton}
        handleRejectButton={handleRejectButton}
        handleCancelButton={handleCancelButton}
        mode={mode}
        okButtonName={okButtonName}
        isOkButtonDisabled={isOkButtonDisabled}
      />
    </Form>
  )
}

MerchantBrandRuleModal.defaultProps = {
  value: {
    id: null,
    merchantId: null,
    merchantName: null,
    brandId: null,
    brandFullPath: null,
    request_notes: null,
    review_notes: null
  },
  isRequest: false,
  isReadOnly: false
}

MerchantBrandRuleModal.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.number,
    merchantId: PropTypes.number,
    merchantName: PropTypes.string,
    brandId: PropTypes.number,
    brandFullPath: PropTypes.string,
    request_notes: PropTypes.string,
    review_notes: PropTypes.string
  }),

  onOkHandler: PropTypes.func.isRequired,
  onRejectHandler: PropTypes.func,

  isRequest: PropTypes.bool,
  isReadOnly: PropTypes.bool
}
